import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { NgxFilesizeModule } from 'ngx-filesize';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { AdminActions } from '../../state/admin.actions';
import { AdminEffect } from '../../state/admin.effect';
import { AdminSelectors } from '../../state/admin.selectors';
import { AdminSatelliteSurveillanceComponent } from './admin-satellite-surveillance.component';
import { SatelliteSurveillanceActions } from './state/satellite-surveillance.actions';
import { SatelliteSurveillanceEffect } from './state/satellite-surveillance.effect';
import {
    satelliteSurveillanceStateReducer
} from './state/satellite-surveillance.reducer';
import { SatelliteSurveillanceSelectors } from './state/satellite-surveillance.selectors';

@NgModule({
    declarations: [
        AdminSatelliteSurveillanceComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgrxFormsModule, // needs FormsModule
        StoreModule.forFeature('satelliteSurveillance', satelliteSurveillanceStateReducer),
        EffectsModule.forFeature([SatelliteSurveillanceEffect, AdminEffect]),
        TableModule,
        MultiSelectModule,
        DropdownModule,
        ButtonModule,
        NgxFilesizeModule,
        TooltipModule
    ],
    providers: [
        SatelliteSurveillanceSelectors,
        AdminSelectors,
        SatelliteSurveillanceActions,
        AdminActions
    ]
})
export class AdminSatelliteSurveillanceModule {
}
